import { CoursesList } from '@/components/courses/CoursesList/CoursesList'
import { LEARN_MY_COURSES_SLUG } from '@/features/layout/LayoutMain/constants'
import { isNewLearnerMF } from '@/features/learnerMF/isNewLearnerMF'
import { useSetActiveSlug } from '@/features/stencil/stubs'

import { useDocTitle } from '@/features/wa/title/useDocTitle'
import { useCoursesTitle } from '@/hooks/useCoursesTitle'
import { CoursesMF } from '@/views/courses/CoursesMF'
import { useOpenCatalogFlow } from '@/views/PublicCatalogRouter/hooks/useOpenCatalogCourseFlow'

export const Home = () => {
  useSetActiveSlug(LEARN_MY_COURSES_SLUG)

  const title = useCoursesTitle()
  useDocTitle(title)

  useOpenCatalogFlow()

  if (isNewLearnerMF()) {
    return <CoursesMF />
  }

  return <CoursesList />
}
